// Use intrinsic label measurements, never the active selection or a smaller font.
// Extra space is shared within each row. Large system text can require more rows.
export function navigationRows(available, labelWidths, {padding=2,minTouch=44}={}) {
 const width=Math.max(1,Math.floor(available));
 const minimum=labelWidths.map(n=>Math.max(minTouch,(Number.isFinite(n)&&n>=0?n:0)+padding*2));
 const groups=[];let row=[],used=0;
 minimum.forEach((size,index)=>{
  if(row.length&&used+size>width){groups.push(row);row=[];used=0;}
  row.push({index,width:Math.min(size,width)});used+=Math.min(size,width);
 });
 if(row.length)groups.push(row);
 // Avoid a five-plus-one row split when a balanced three-plus-three fits.
 for(let i=groups.length-1;i>0;i--){
  const previous=groups[i-1],last=groups[i];
  while(previous.length>last.length+1&&last.reduce((sum,item)=>sum+item.width,0)+previous.at(-1).width<=width)last.unshift(previous.pop());
 }
 return groups.map(items=>{
  const extra=Math.max(0,width-items.reduce((sum,item)=>sum+item.width,0));
  return items.map(item=>({...item,width:item.width+extra/items.length}));
 });
}
